import React, { useState } from 'react';
import { Mention, MentionsInput } from 'react-mentions';
import { useUser } from '~/providers/user';
import { useComment } from '../providers';
import { PostCommentButton } from './post_comment';
const CommentInput = (props) => {
    const { commentsCount, documentComparisonId } = props;
    const { taggableComparisonUsers } = useUser();
    const [commentText, setCommentText] = useState('');
    const [taggedUserIds, setTaggedUserIds] = useState([]);
    const { addComment, isPostingComment } = useComment();
    const handlePostComment = (selectedPrivilegeGroups) => {
        if (!commentText) {
            return;
        }
        const formattedText = commentText.replace(/\[(.*?)\]/gi, '');
        addComment(formattedText, documentComparisonId, selectedPrivilegeGroups, taggedUserIds);
        setCommentText('');
        setTaggedUserIds([]);
    };
    const handleChange = (_, newValue, plainTextValue, mentions) => {
        setCommentText(newValue);
        setTaggedUserIds(mentions.map(mention => mention.id));
    };
    const users = taggableComparisonUsers.map(user => (Object.assign(Object.assign({}, user), { display: user.name })));
    return (React.createElement("div", { className: 'comment-input' },
        React.createElement("div", { className: 'add-comment-input' },
            React.createElement(MentionsInput, { placeholder: 'Add your thoughts. Mention others with \'@\'', value: commentText, onChange: handleChange, className: 'mentions' },
                React.createElement(Mention, { trigger: '@', data: users, markup: '{uid:__id__[__display__]}', displayTransform: (id, display) => `@${display}`, className: 'mentions__mention' }))),
        React.createElement("div", { className: 'comment-actions' }, (commentsCount > 0 || commentText !== '' || isPostingComment) &&
            React.createElement(PostCommentButton, { taggedUserIds: taggedUserIds, disabled: !commentText, handlePost: handlePostComment }))));
};
export default CommentInput;
